import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { RIGHT_SLIDES } from '../constants';
import { LabConfig } from '../types';
import { StarField } from './utils/StarField';
import { SwirlHero } from './utils/SwirlHero';

interface ProjectSliderProps {
  lab: LabConfig;
}

export function ProjectSlider({ lab }: ProjectSliderProps) {
  const [i, setI] = useState(0);
  const len = RIGHT_SLIDES.length;
  const prev = () => setI((v) => (v - 1 + len) % len);
  const next = () => setI((v) => (v + 1) % len);

  return (
    <SwirlHero full gain={lab.gain} flare={lab.flare} noise={lab.noise} mode={lab.mode} gradientColors={RIGHT_SLIDES[i].gradientColors}>
      <div className="absolute inset-0 overflow-hidden">
        <div className="flex h-full w-full transition-transform duration-500" style={{ transform: `translateX(-${i * 100}%)` }}>
          {RIGHT_SLIDES.map((s) => (
            <div key={s.id} className="relative h-full w-full shrink-0">
                             {s.id === 'solar' ? (
                 <StarField />
               ) : s.id === 'trace' ? (
                 <div className="absolute inset-0">
                                       <img 
                      src="/TRACE.png" 
                      alt="TRACE." 
                      className="h-full w-full object-cover opacity-60"
                    />
                 </div>
               ) : (
                 <div className="absolute inset-0 opacity-70" style={{ background: s.bg }} />
               )}

              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4 sm:p-6">
                <div>
                  <h3
                    className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight"
                    style={{
                      fontFamily:
                        '"SF Pro Display", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, "Segoe UI", Roboto, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                    }}
                  >
                    {s.title}
                  </h3>
                  {s.id === 'solar' ? (
                    <p className="text-white/80 text-sm sm:text-base italic max-w-[48ch]">
                      We are made of star-stuff. We are a way for the cosmos to know itself.
                    </p>
                  ) : (
                    <p className="text-white/70 text-sm sm:text-base">{s.subtitle}</p>
                  )}
                </div>
                                                 <a 
                  href={s.id === 'solar' ? 'https://cosmos.hugoesquerdo.com' : 'https://trace.hugoesquerdo.com'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-2 text-sm font-medium text-white/90 backdrop-blur hover:bg-white/10 transition-colors"
                >
                  navigate →
                </a>
              </div>
            </div>
          ))}
        </div>

        <button aria-label="Previous" onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full border border-white/15 bg-white/5 p-2 text-white/80 hover:bg-white/10">
          <ChevronLeft className="h-5 w-5" />
        </button>
        <button aria-label="Next" onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full border border-white/15 bg-white/5 p-2 text-white/80 hover:bg-white/10">
          <ChevronRight className="h-5 w-5" />
        </button>

        <div className="pointer-events-none absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {RIGHT_SLIDES.map((_, idx) => (
            <span key={idx} className={`h-1.5 w-4 rounded-full ${i===idx? 'bg-white/80':'bg-white/30'}`} />
          ))}
        </div>
      </div>
    </SwirlHero>
  );
}
